import React from 'react';

type StatsProps = {
    stats5: { workdays: number; workHours: number; celebrationCount: number };
    stats6: { workdays: number; workHours: number; celebrationCount: number };
    workWeek: 'five' | 'six'; 
};

const Stats = ({ stats5, stats6, workWeek }: StatsProps) => {
    const stats = workWeek === 'five' ? stats5 : stats6;
    const label = workWeek === 'five' ? '5 dienų savaitė' : '6 dienų savaitė';

    return (
        <div className="mt-4 space-y-2 text-sm">
            <div className="bg-gray-100 p-3 rounded">
                <h2 className="font-semibold text-gray-800 mb-1">{label}:</h2>
                <p>Darbo dienų: <strong>{stats.workdays}</strong></p>
                <p>Darbo valandų: <strong>{stats.workHours}</strong></p>
            </div>
        </div>
    );
};

export default Stats;
